import { api } from "../../services/Api.js";

export function add_avatar({ commit, state }, payload ){

    // adding token
    payload.token=state.appSettings.token
    // get active school
    var school = state.user_schools.find(school => school.active === 1);
    
    
        
    return api.post(school,"add_avatar.php",payload)
    .then(result=>{
        //var timestamp="?ts="+new Date().getTime();
        // we get back an url from api call that is the same thumb every time
        commit('SET_AVATAR',result.data.avatar);
        return result;
    });

   
  }